import { useContext, useEffect, useState } from "react"
import services from "../../../services/services";
import { Urls } from "../../../services/Urls";
import { decryptData } from "../../../utils/encrypt";
import _ from "underscore";
import { dateConvert } from "../../../utils/Helper";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ToastContext } from "../../../context/ToastContext";

export const useCheckBlocking = ({ projectChanged }) => {

    const { showSuccess } = useContext(ToastContext);
    const [rowData, setRowData] = useState([]);
    const [loader, setLoader] = useState(false);
    const [filterValue, setFilterValue] = useState({ BlockingDurationThreshold: 10, BlockedSessionThreshold: 0, isChange: true })
    const leadBlockerCols = [
        {
            key: "leadingBlocker",
            label: "Leading Blocker",
            headerStyle: { textAlign: "center" },
            style: { width: "100px", textAlign: "center" },
        },
        {
            key: "blockedSpidCount",
            label: "Blocked SPID",
            headerStyle: { textAlign: "center" },
            style: { width: "100px", textAlign: "center" },
        },
        {
            key: "dbName",
            label: "DB Name",
            style: { width: "200px" },
        },
        {
            key: "hostName",
            label: "Host Name",
            style: { width: "200px" },
        },
        {
            key: "loginName",
            label: "Login Name",
            style: { width: "200px" },
        },
        {
            key: "programName",
            label: "Program Name",
            style: { width: "200px" },
        },
        {
            key: "loginTime",
            label: "Login Time",
            style: { width: "300px" },
        },
        {
            key: "lastRequestStart",
            label: "Last Request Start",
            style: { width: "200px" },
        },
        {
            key: "lastRequestEnd",
            label: "Last Request End",
            style: { width: "200px" },
        },
        {
            key: "transactionCnt",
            label: "Tx Count",
            headerStyle: { textAlign: "center" },
            style: { width: "150px", textAlign: "center" },
        },
        {
            key: "command",
            label: "Command",
            style: { width: "150px" },
        },
        {
            key: "waitTime",
            label: "Wait Time ms",
            headerStyle: { textAlign: "center" },
            style: { width: "120px", textAlign: "center" },
            render: (row) => <span>{row?.waitTime?.toLocaleString() || 0}</span>
        },
        {
            key: "waitResource",
            label: "Wait Resource",
            style: { width: "120px" },
            render: (row) => <span title={row?.waitResource}>{row?.waitResource || "None"}</span>
        },
        {
            key: "waitDescription",
            label: "Wait Description",
            style: { width: "200px" },
            render: (row) => <span title={row?.waitDescription}>{row?.waitDescription || "None"}</span>
        },
        {
            key: "sqlStatement",
            label: "Active SQL Statement",
            style: { width: "300px" },
        },
        {
            key: "sqlText",
            label: "Full SQL Text",
            style: { width: "300px" },
            render: (row) => {
                return (
                    <p title={row?.sqlText} className="text-truncate c-pointer" onClick={() => handleCopy(row?.sqlText)}>{row?.sqlText}</p>
                );
            }
        },
        {
            key: "inputBuffer",
            label: "Input Buffer",
            style: { width: "300px" },
            render: (row) => {
                return (
                    <p title={row?.inputBuffer} className="text-truncate c-pointer" onClick={() => handleCopy(row?.inputBuffer)}>{row?.inputBuffer}</p>
                );
            }
        },
        {
            key: "sessionInfo",
            label: "Session Info (XML)",
            style: { width: "300px" },
            render: (row) => {
                return (
                    <p title={row?.sessionInfo} className="text-truncate c-pointer" onClick={() => handleCopy(row?.sessionInfo)}>{row?.sessionInfo}</p>
                );
            }
        }
    ];

    const blockedSessionsCols = [
        {
            key: "waitingSpid",
            label: "Waiting SPID",
            headerStyle: { textAlign: "center" },
            style: { width: "100px", textAlign: "center" },
        },
        {
            key: "blockingSpid",
            label: "Blocking SPID",
            headerStyle: { textAlign: "center" },
            style: { width: "100px", textAlign: "center" },
        },
        {
            key: "leadingBlocker",
            label: "Leading Blocker",
            headerStyle: { textAlign: "center" },
            style: { width: "100px", textAlign: "center" },
        },
        {
            key: "blockingChain",
            label: "Blocking Chain",
            headerStyle: { textAlign: "center" },
            style: { width: "150px", textAlign: "center" },
        },
        {
            key: "dbName",
            label: "DB Name",
            style: { width: "200px" },
        },
        {
            key: "hostName",
            label: "Host Name",
            style: { width: "200px" },
        },
        {
            key: "loginName",
            label: "Login Name",
            style: { width: "150px" },
        },
        {
            key: "programName",
            label: "Program Name",
            style: { width: "200px" },
        },
        {
            key: "loginTime",
            label: "Login Time",
            style: { width: "200px" },
        },
        {
            key: "lastRequestStart",
            label: "Last Request Start",
            style: { width: "200px" },
        },
        {
            key: "lastRequestEnd",
            label: "Last Request End",
            style: { width: "200px" },
        },
        {
            key: "transactionCnt",
            label: "Tx Count",
            headerStyle: { textAlign: "center" },
            style: { width: "150px", textAlign: "center" },
        },
        {
            key: "command",
            label: "Command",
            headerStyle: { textAlign: "center" },
            style: { width: "150px", textAlign: "center" },
        },
        {
            key: "waitTime",
            label: "Wait Time ms",
            headerStyle: { textAlign: "center" },
            style: { width: "200px", textAlign: "center" },
            render: (row) => <span>{row?.waitTime?.toLocaleString() || 0}</span>
        },
        {
            key: "waitResource",
            label: "Wait Resource",
            style: { width: "200px" },
            render: (row) => {
                return <p title={row?.waitResource} className=" text-truncate">{row?.waitResource}</p>
            }
        },
        {
            key: "waitDescription",
            label: "Wait Description",
            style: { width: "200px" },
            render: (row) => {
                return <p title={row?.waitDescription} className=" text-truncate">{row?.waitDescription}</p>
            }
        },
        {
            key: "sqlStatement",
            label: "SQL Statement",
            style: { width: "200px" },
            render: (row) => {
                return <p title={row?.sqlStatement} className=" text-truncate">{row?.sqlStatement}</p>
            }
        },
        {
            key: "sqlText",
            label: "Full SQL Text",
            style: { width: "250px" },
            render: (row) => {
                return (
                    <p title={row?.sqlText} className="text-truncate c-pointer" onClick={() => handleCopy(row?.sqlText)} >{row?.sqlText}</p>
                );
            }
        },
        {
            key: "inputBuffer",
            label: "Input Buffer",
            style: { width: "250px" },
            render: (row) => {
                return (
                    <p title={row?.inputBuffer} className="text-truncate c-pointer" onClick={() => handleCopy(row?.inputBuffer)} >{row?.inputBuffer}</p>
                );
            }
        },
        {
            key: "sessionInfo",
            label: "Session Info (XML)",
            style: { width: "300px" },
            render: (row) => {
                return (
                    <p title={row?.sessionInfo} className="text-truncate c-pointer" onClick={() => handleCopy(row?.sessionInfo)}>{row?.sessionInfo}</p>
                );
            }
        }
    ];


    const handleCopy = (text) => {
        if (!text) return;
        navigator.clipboard.writeText(text)
            .then(() => showSuccess("Success", "Copied!"))
            .catch((err) => console.error("Failed to copy: ", err));
    };
    useEffect(() => {
        getCheckBlocking()
    }, [projectChanged])

    useEffect(() => {
        const interval = setInterval(() => {
            getCheckBlocking();
        }, 120000);

        return () => clearInterval(interval);
    }, []);

    const getCheckBlocking = async () => {
        try {
            const selectedProject = sessionStorage.getItem("inspectra_project") ? JSON.parse(decryptData(sessionStorage.getItem("inspectra_project"))) : {};
            if (!_.isEmpty(selectedProject)) {
                setLoader(true)
                const payload = {
                    "project_id": selectedProject?.project_id,
                    "BlockingDurationThreshold": filterValue?.BlockingDurationThreshold || 0,
                    "BlockedSessionThreshold": filterValue?.BlockedSessionThreshold || 0
                }
                const response = await services.getInvokeRemote("POST", Urls("GETCHECKBLOCKING"), payload);
                if (response?.body?.data) {
                    setRowData(response?.body?.data)
                } else {
                    setRowData([])
                }
                setFilterValue((prev) => ({ ...prev, isChange: false }))
                setLoader(false)
            }

        } catch (error) {
             setLoader(false)
            console.error("error::", error)
        }
    }

    const handleChange = (e) => {
        const { name, value } = e.target
        if (name === "BlockingDurationThreshold") {
            setFilterValue({ [name]: value, BlockedSessionThreshold: 0, isChange: true })
        } else {
            setFilterValue({ [name]: value, BlockingDurationThreshold: 0, isChange: true })
        }

    }

    return {
        leadBlockerCols,
        blockedSessionsCols,
        rowData,
        loader,
        filterValue,
        handleChange,
        getCheckBlocking

    }
}